// Called by : src/components/question/Question.vue (answer-open)

<template>
  <base-modal ref="base-modal" pageId="answer_open" pageClass="answer" modalClass="modal-lg" modalDataBack="true" modalDataKey="true" :key="keyModal">

    {{ forceUpdate }}

    <template #header>
      <h2 id="answer_open_title" class="modal-title " :class="getClassTitle()">
        <sound-player :url="question.audioQuestion" role="answerQuestion" tone="btn-outline-warning mr-3"></sound-player>
        <span v-html="questionQuestion"></span>
        <!-- {{ questionQuestion }} -->
      </h2>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    
    <template #body>

      <div v-if="answerType===1">
        <!-- answerType = 1 : répnse libre de type texte -->
        <div class="form-row">
          <textarea v-model="answer" ref="rTxt" name="answer_open_input" id="answer_open_input" class="text_area form-control py-xs-1 px-xs-2 py-sm-2 px-sm-3" rows="10" cols="" placeholder=""></textarea>
        </div>
      </div>

      <div v-if="answerType===2">
        <!-- answerType = 2 : répnse libre de type date -->
        <div ref="rFormJour" id="form_jour" class="form-row">
          <div class="input-group input-group-lg">
            <label for="answer_open_input_jour" class="input-group-prepend w-50">
              <span id="answer_open_label_jour" class="label_text input-group-text w-100">{{ $t('answer.openDay') }}</span>
            </label>
            <input type="number" v-model.number="answerJour" v-on:input="setDateValid" v-on:keypress="isNumber" name="answer_open_input_jour" id="answer_open_input_jour" min="1" max="31" step="1" class="form-control text-center " placeholder="" required>
          </div>
        </div>

        <div ref="rFormMois" id="form_mois" class="form-row"> 
          <div class="input-group input-group-lg">
            <label for="answer_open_input_mois" class="input-group-prepend w-50">
              <span id="answer_open_label_mois" class="label_text input-group-text w-100">{{ $t('answer.openMonth') }}</span>
            </label>
            <input type="number" v-model.number="answerMois" v-on:input="setDateValid" v-on:keypress="isNumber" name="answer_open_input_mois" id="answer_open_input_mois" min="1" max="12" step="1" class="form-control text-center" placeholder="" required>
          </div>
        </div>

        <div ref="rFormAnnee" id="form_annee" class="form-row"> 
          <div class="input-group input-group-lg">
            <label for="answer_open_input_annee" class="input-group-prepend w-50">
              <span id="answer_open_label_annee" class="label_text input-group-text w-100">{{ $t('answer.openYear') }}</span>
            </label>
            <input type="number" v-model.number="answerAnnee" v-on:input="setDateValid" v-on:keypress="isNumber" name="answer_open_input_annee" id="answer_open_input_annee" min="1000" max="3000" step="1" class="form-control text-center" placeholder="" required>
          </div>
        </div>

        <div class="form-row">
          <div class="alert alert-info text-center w-100" role="alert">
            <h4 class="m-0">{{ answer }}</h4>
          </div>
        </div>
        
        <div ref="rErrDate" id="form_error_date" class="form-row d-none">
          <div class="alert alert-danger text-center w-100 border-danger" role="alert">
            <h5 class="m-0">{{ $t('answer.openError') }}</h5>
          </div>
        </div>

        <div class="form-row mt-3">
          <button type="button" class="btn btn-outline-secondary btn-lg btn-block" @click="setToday">
            <span class="oi oi-calendar mr-2"></span>
            {{ $t('answer.openToday') }}
          </button>
        </div>
      </div>

      <div v-if="answerType===3">
        <!-- answerType = 3 : répnse libre de type heure -->
        <div ref="rFormHrs" id="form_hrs" class="form-row"> 
          <div class="input-group input-group-lg">
            <label for="answer_open_input_hrs" class="input-group-prepend w-50">
              <span id="answer_open_label_hrs" class="label_text input-group-text w-100">{{ $t('answer.openHours') }}</span>
            </label>
            <input type="number" v-model.number="answerHrs" v-on:input="setHourValid" v-on:keypress="isNumber" name="answer_open_input_hrs" id="answer_open_input_hrs" min="0" max="23" step="1" class="form-control text-center" placeholder="" required>
          </div>
        </div>

        <div ref="rFormMin" id="form_min" class="form-row">
          <div class="input-group input-group-lg">
            <label for="answer_open_input_min" class="input-group-prepend w-50">
              <span id="answer_open_label_min" class="label_text input-group-text w-100">{{ $t('answer.openMinutes') }}</span>
            </label>
            <input type="number" v-model.number="answerMin" v-on:input="setHourValid" v-on:keypress="isNumber" name="answer_open_input_min" id="answer_open_input_min" min="0" max="59" step="1" class="form-control text-center" placeholder="" required>
          </div>
        </div>

        <div class="form-row">
          <div class="alert alert-info text-center w-100" role="alert">
            <h4 class="m-0">{{ answer }}</h4>
          </div>
        </div>

        <div ref="rErrHrs" id="form_error_hrs" class="form-row d-none">
          <div class="alert alert-danger text-center w-100 border-danger" role="alert">
            <h5 class="m-0">{{ $t('answer.openError') }}</h5>
          </div>
        </div>

        <div class="form-row mt-3">
          <button type="button" class="btn btn-outline-secondary btn-lg btn-block" @click="setNow">
            <span class="oi oi-clock mr-2"></span>
            {{ $t('answer.openNow') }}
          </button>
        </div>
      </div>

      <div v-if="answerType===4">
        <!-- answerType = 4 : répnse libre de type nombre -->
        <div ref="rFormNbr" id="form_nbr" class="form-row">
          <div class="input-group input-group-lg">
            <label for="answer_open_input_nbr" class="input-group-prepend w-50">
              <span id="answer_open_label_nbr" class="label_text input-group-text w-100">{{ repLibreLabel }}</span>
            </label>
            <input type="number" v-model.number="answer" v-on:keypress="isNumber" name="answer_open_input_nbr" id="answer_open_input_nbr" min="" max="" step="1" class="form-control text-center" placeholder="" required>
            <label for="answer_open_input" class="input-group-append">
              <span class="label_text input-group-text">{{ repLibreUnit }}</span>
            </label>
          </div>
        </div>
      </div>

    </template>
    
    <template #footer>
      <button type="submit" class="btn_modal_submit btn btn-primary btn-lg btn-block" :disabled="getDisabled()" @click.stop="save">
        <span class="oi oi-check mr-2"></span>
        {{ $t('modals.validate') }}
      </button>
    </template>

  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal'
import SoundPlayer from '@/components/misc/SoundPlayer'

export default {
  components: {
    BaseModal,
    SoundPlayer,
  },
  props: {
    question: Object,
    isfr: Boolean,
  },
  data() {
    return {
      questionQuestion: '',
      langFr: true,
      answer: '',
      answerType: 1,
      answerBad: false,
      answerHrs: false,
      answerMin: false,
      answerJour: false,
      answerMois: false,
      answerAnnee: false,
      keyModal: false,
      repLibreUnit: '',
      repLibreLabel: '',
    }
  },
  methods: {
    save() {
      var bDate = Boolean(this.answerType === 2);
      if ((this.answerType === 2) || (this.answerType === 3)) this.setAnswer(bDate);
      var sAnswer = this.answer;
      this.answer = '';
      this.answerType = 1;
      this.answerBad = false;
      this.answerHrs = false;
      this.answerMin = false;
      this.answerJour = false;
      this.answerMois = false;
      this.answerAnnee = false;
      this.repLibreUnit = '';
      this.repLibreLabel = '';
      $('#answer_open').modal('hide');
      this.$emit('save', sAnswer);
      // data-dismiss="modal"
    },
    getClassTitle() {
      return { 'answer_open_title': this.question.audioQuestion }
    },
    getDisabled() {
      let bOff = Boolean(!this.answer || this.answerBad);
      f_setModalBtnOff_v(bOff);
      return bOff;
    },
    setHourValid() {
      let oFormHrs = this.$refs.rFormHrs;
      let oFormMin = this.$refs.rFormMin;
      let oErrHrs = this.$refs.rErrHrs;
      let bErrHrs = Boolean((this.answerHrs < 0) || (this.answerHrs > 23));
      let bErrMin = Boolean((this.answerMin < 0) || (this.answerMin > 59));
      let bErr = Boolean(bErrHrs || bErrMin);
      this.answerBad = bErr;
      this.setAnswer(false);
      this.setClass(oFormHrs,bErrHrs,'is_error');
      this.setClass(oFormMin,bErrMin,'is_error');
      this.setClass(oErrHrs,!bErr,'d-none');
    },
    setDateValid() {
      let oFormJour = this.$refs.rFormJour;
      let oFormMois = this.$refs.rFormMois;
      let oFormAnnee = this.$refs.rFormAnnee;
      let oErrDate = this.$refs.rErrDate;
      let bErrJour = Boolean((this.answerJour < 1) || (this.answerJour > 31));
      let bErrMois = Boolean((this.answerMois < 1) || (this.answerMois > 12));
      let bErrAnnee = Boolean((this.answerAnnee < 1000) || (this.answerAnnee > 3000));
      let bErr = Boolean(bErrJour || bErrMois || bErrAnnee);
      this.answerBad = bErr;
      this.setAnswer(true);
      this.setClass(oFormJour,bErrJour,'is_error');
      this.setClass(oFormMois,bErrMois,'is_error');
      this.setClass(oFormAnnee,bErrAnnee,'is_error');
      this.setClass(oErrDate,!bErr,'d-none');
    },
    setClass(oObj,bAdd,sClass) {
      if (bAdd) {
        oObj.classList.add(sClass);
      } else {
        oObj.classList.remove(sClass);
      }
    },
    setInputFocus(sId) {
      let sSel = 'input#answer_open_input_' + sId;
      $(sSel).focus().select();
    },
    setAnswer(bDate) {
      if (bDate) {
        let sJour = ('0' + this.answerJour).slice(-2);
        let sMois = ('0' + this.answerMois).slice(-2);
        this.answer = "".concat(this.answerAnnee,'/',sMois,'/',sJour);
        // this.answer = "".concat(sMois,'/',sJour,'/',this.answerAnnee);
      } else {
        let sHrs = ('0' + this.answerHrs).slice(-2);
        let sMin = ('0' + this.answerMin).slice(-2);
        this.answer = "".concat(sHrs,':',sMin,':00');
        // this.answer = "".concat(sHrs,':',sMin);
      }
    },
    isNumber(event) {
      const charCode = event.keyCode
      let bOk = Boolean((charCode >= 44) && (charCode <= 57) && (charCode !== 47))
      if (bOk) {
        return true;
      } else {
        event.preventDefault()
      }
    },
    setToday() {
      this.answerJour = f_getDateDay_s(false);
      this.answerMois = f_getDateMonth_s(false);
      this.answerAnnee = f_getDateYear_s(true);
      this.setAnswer(true);
      this.setDateValid();
    },
    setNow() {
      this.answerHrs = f_getDateHours_s(false);
      this.answerMin = f_getDateMinutes_s(false);
      this.setAnswer(false);
      this.setHourValid();
    },
    getKey(sId) {
      return sId + f_getRandomMinMax_n(100000000, 999999999);
      // https://michaelnthiessen.com/force-re-render/
      // https://michaelnthiessen.com/key-changing-technique/
    },
    setInit(bStart) {
      // @@@ Fredo : nouvelle approche, via une seule rubrique "question.repLibreType" : 1 = texte ; 2 = date ; 3 = heure ; 4 = nombre
      this.answerType = Number(this.question.repLibreType);
      this.repLibreUnit = this.question.repLibreUnit;
      this.repLibreLabel = this.question.repLibreLabel;
      if(!this.repLibreUnit) this.repLibreUnit = this.$t('answer.openEurosSigle');
      if(!this.repLibreLabel) this.repLibreLabel = this.$t('answer.openAmount');

      if (bStart) {
        this.answer = '';
        this.answerBad = false;
        this.keyModal = false;
        if (this.answerType === 2) this.setToday();
        if (this.answerType === 3) this.setNow();
      } else {
        var bDate = Boolean(this.answerType === 2);
        if ((this.answerType === 2) || (this.answerType === 3)) this.setAnswer(bDate);
        if (!this.keyModal) this.keyModal = this.getKey('ModalOpen');
      }
    },
  },
  computed: {
    forceUpdate() {
      // this.langFr = Boolean(this.lesson.lang.toLowerCase() === "fr");
      this.questionQuestion = (this.isfr) ? f_setCleanSpacesFr_s(this.question.question) : this.question.question;
      this.setInit(false);
      return '';
    },
  },
  mounted: function() {
    this.setInit(true);
  },
  updated: function() {
    // this.setInit();
  },
}
</script>

<style scoped>
h2.answer_open_title {
  padding-left: 56px !important;
  text-indent: -56px !important;
}
span.label_text {
  background-color: #f4f6f8 !important;
}
div.form-row.is_error > div > label > span.label_text {
  font-weight: bold !important;
  border-color: #dc3545 !important;
}
div.form-row.is_error > div > input.form-control {
  font-weight: bold !important;
  color: #721c24 !important;
  border-color: #dc3545 !important;
  background-color: #f8d7da !important;
}
</style>



// WEBPACK FOOTER //
// src/components/question/AnswerOpen.vue